export default "__VITE_ASSET__BFjQXk6$__"